
import { Space, Text } from '@mantine/core'
import { GetServerSideProps } from 'next'
import Head from 'next/head'

import { useRouter } from 'next/router'

import EmailSignupBanner from '../../components/EmailSignupBanner'
import { MenuId } from '../../components/Header'
import Layout from '../../components/Layout'
import { getJWTTokenFromUser, getUserInformation } from '../../lib/data'
import { ImageSearchResult, Photo, RusAuthProps, RusContextProps, SearchJson, SubscriberLevel } from '../../lib/definitions'

import styles from './[...image].module.scss'
import Link from 'next/link'
import { AspectBox } from '../../components/AspectBox'

//This isn't cached for logged on users
//But is cached if you're not
type Data = {
    image: Photo,
    accessible: boolean,
    canonicalUrl?: string
    }

export default function VideoPage({data} : {data: Data} & RusAuthProps & RusContextProps)
{

  let router = useRouter();

  let logonUrl="/log-in?redirect_to=" + router.asPath;

  //const { video } = router.query

  //should only get here if video is in the future AND it's not accessible
  //OR it's in the past (and may or may not be accessible)
    let d = data.image?.description;

  return(
  <Layout menuId={MenuId.online}>

  <Head>
      <title>{data.image?.description}</title>
      <meta name="description" content={d}/>
      <meta property='og:title' content={d}/>
      <meta property='og:description' content={`${d} - a reference image from Raw Umber Studios`}/>
      <meta property='og:image' content={`${data.image?.pixelatedFile}`}/>
      <meta property='og:image-width' content={`{data.image.thumbnailWidth`}/>
      <meta property='og:image-height' content={`{data.image.thumbnailHeight`}/>

      <link rel='canonical' href={data.canonicalUrl} key="canonical"/>

  </Head>
  <div className = {styles.mainContent}>
  <h1 className={styles.h1}>{data.image?.description}</h1>
  <h2 className={styles.h2}>An image from the <Link href='/image-search'>Raw Umber Studios reference library</Link></h2>
    <div style={{width:"100%", maxWidth:"640px"}}>
    <AspectBox width={data.image.thumbnailWidth} height={data.image.thumbnailHeight}>
        {/*eslint-disable-next-line @next/next/no-img-element*/}
        <img style={{width:"100%"}} alt={d} src={data.accessible?data.image.imageFile:data.image.pixelatedFile}></img>
    </AspectBox>
    </div>
  <div>
    <Space h='md'></Space>

      <Text align='center'>You may use this photograph for drawing, painting and sculpting from. You may share or sell your work. <strong>You may not, however, distribute the original images or use them for any other purposes.</strong> The copyright of the photograph remains with the photographer.</Text>
  
      <Space h='md'></Space>
    {!data.accessible && <Text align='center'>To see this image in full resolution, please <Link href={logonUrl}>log on</Link> or <Link href='/subscription'>purchase a subscription.</Link></Text>}
   
    <Text align='center'>To see more images, check out our <Link href='/image-search'>searchable image reference library</Link></Text>
   
  </div>
 
  </div>
  <Space h="lg" />
  <EmailSignupBanner/>
</Layout>
  );
  }

  function sanitizeName(name:string)
  {
    if (!name)
    {
      return '';
    }
    let n2 = name.replace(/[^a-zA-z0-9]/g,'-');
    return n2;
  }
export const getServerSideProps : GetServerSideProps = async (context)=>
{

    let user = await getUserInformation(context?.req?.headers.cookie);

    
    let token;

    if (user.subscribed)
    {
        token = await getJWTTokenFromUser(user);
    }

    const id = (context.params?.image as string [])[0];

    if (isNaN(Number(id)))
    {
        return {notFound: true};
    }

    let options = { 
        method: 'GET',
        cache: "no-store" as RequestCache
        };

    if (token)
    {
        (options as any).headers = {'auth-token': token}
    }


    let sd : SearchJson = {
        PhotoId: Number(id),
        Count:1,
        Offset:0
    }

    let json = encodeURIComponent(JSON.stringify(sd, (_, v) => { if (v != null) return v; }));

    const result: ImageSearchResult = await (await fetch(process.env.NEXT_PUBLIC_ELTON_ROUTE + "/imagesearch?json=" + json, options)).json();

    if (result.count!=1)
    {
        return {notFound: true};
    }

    let photo = result.photos[0];

    let ret: Data =
    {
        accessible: !!(user.subscriber_level==SubscriberLevel.gold || user.subscriber_level== SubscriberLevel.image || photo.isFree),
        image: photo,
        canonicalUrl: process.env.ROOT_PATH + "/image-library/" + photo.id + "/" + sanitizeName(photo.description)
    }

      return {
      props: {
        data: ret
      
      }
    }
  }

  